import { useEffect } from 'react';
import { Button } from '@repo/atomic-components';

export const NewVersionBanner = () => {
  useEffect(() => {
    document.documentElement.style.setProperty('--new-version-banner-h', '40px');
    return () => {
      document.documentElement.style.removeProperty('--new-version-banner-h');
    };
  }, []);

  return (
    <div className="bg-theme-dark-green text-theme-white fixed top-0 right-0 left-0 z-50 flex h-10 items-center justify-center gap-4 px-6 text-sm font-medium">
      <span>A new version of Fletch is available.</span>
      <Button
        className="!text-theme-dark-green !bg-theme-white h-7 px-3 text-xs font-semibold"
        onClick={() => window.location.reload()}
      >
        Reload
      </Button>
    </div>
  );
};
